export const RELEVANCE_UPDATE_SUCCESSFUL_TOAST_MESSAGE = 'Relevance has been updated';
export const RELEVANCE_UPDATE_FAILURE_TOAST_MESSAGE = 'Relevance has not been updated';
export const CHARTS_UPDATED_AFTER_RELEVANCE_UPDATE_TOAST_MESSAGE = 'Charts now reflect relevance update';
export const POST_COUNTS_UPDATED_AFTER_RELEVANCE_UPDATE_TOAST_MESSAGE = 'Post counts now reflect relevance update';


// WEBPACK FOOTER //
// ./src/features/home/constants/DisplayedTextConstants.js